
const API_BASE_URL = 'https://api.erma-app.com';

module.exports = Object.freeze(
  {
    FeatureToggle: {
      CompleteInventoryEnabled: true
    },

    ServiceAPI: {
      baseUrl: `${API_BASE_URL}`,
      inventoryUrl: `${API_BASE_URL}/api/inventory/`,
      authenticateUrl: `${API_BASE_URL}/api/authenticate/`,
      HoseManagementUrl: `${API_BASE_URL}/api/hose/`,
      HoseTestUrl: `${API_BASE_URL}/api/hose/test/`,
      HoseHistoryUrl: `${API_BASE_URL}/api/hose/history/`
    },

    Http: {
      Method: {
        GET: 'GET',
        POST: 'POST',
        PUT: 'PUT',
        DELETE: 'DELETE'
      },
      
      Status: {
        OK: 200,
        INTERNAL_ERROR: 500
      },

      Param: {
        Id: "id",
        ContainerId: "cId"
      }
    },
    
    InventoryType: {
      Item: 'item',
      Container: 'container',
      Inventory: 'inventory'
    },

    UserRole: {
      InventoryManager: "MANAGER",
      InventoryUser: "USER",
      HoseManager: "EH_MANAGER",
      HoseUser: "EH_USER" 
    },
    
    RoutePath: {
      Home: "/",
      SignUp: "/signup",
      Login: "/login",
      Logout: "/logout",
      Landing: "/landing",

      Inventory: {
        List: '/inventory/listing',
        Create: '/inventory/create',
        Edit: (id) => { return `/inventory/edit/${id}`; },
        Pdf: (id) => { return `/inventory/print/${id}`; },
        Complete: (id) => { return `/inventory/complete/${id}`; },
        CompleteLocker: (id) => { return `/inventory/complete/locker/${id}` },
        Manage: '/inventory/manage'
      },

      HoseManagement: {
        Listing: '/hoses/listing',
        Edit: (id) => { return `/hoses/edit/${id}`; },
        Test: (id) => { return `/hoses/test/${id}`; },
        History: (id) => { return `/hose/history/${id}`; }
      }, 

      Gallery: {
        View: '/inventory/gallery'
      }
    },

    Misc: {
      ImageDataTag: "data:image/jpeg;base64,",
      ImageSizePx: 300
    }

  }
);
